Vue.component("range-slider", {
    props: ['title', 'min', 'max', 'value', 'id', 'icon', 'int', 'checkbox', 'picked', 'isSlider', 'identifier'],
    data: function () {
        return {
            slider: null,
            active: false
        }
    },
    mounted: function () {
        var _this = this;

        _this.slider = document.getElementById(_this.id);

        noUiSlider.create(_this.slider, {
            start: _this.min,

            connect: 'lower',
            format: {
                to: function (value) {
                    if (!_this.int) {
                        return parseFloat(value).toFixed(2);
                    } else {
                        return parseInt(value);
                    }
                },
                from: function (value) {
                    if (!_this.int) {
                        return parseFloat(value).toFixed(2);
                    } else {
                        return parseInt(value);
                    }
                }
            },
            range: {
                'min': _this.min,
                'max': _this.max
            }
        });

        _this.slider.noUiSlider.on('start', function (values, handle) {
            _this.active = true;
        });
        _this.slider.noUiSlider.on('end', function (values, handle) {
            _this.active = false;
        });
        _this.slider.noUiSlider.on('slide', function (values, handle) {
            _this.value = parseInt(values[handle]);
            _this.$emit('update:value', _this.value);
            _this.$parent.calculate(_this.slider.id);
        });


        _this.$emit('update:value', _this.value);
    },
    methods: {
        update: function (e) {
            var _this = this;
            if (e.target.value) {
                var newValue = parseFloat(e.target.value);
                if (newValue > _this.max) {
                    newValue = _this.max;
                }
                if (newValue < _this.min) {
                    newValue = _this.min;
                }
                _this.value = newValue;
                _this.$emit('update:value', _this.value);

                _this.slider.noUiSlider.set(_this.value);
                _this.$parent.calculate(e.target.id);
            }
        },
        pick: function (e) {
            var _this = this;
            _this.$emit('update:picked', _this.picked);
            _this.$parent.calculate(e.target.value);
        },
        handleInput: function () {
            var _this = this;
            _this.$emit('update:value', _this.value);
            _this.$parent.calculate(_this.slider.id);
            _this.slider.noUiSlider.set(_this.value);
        }
    },
    watch: {
        value: function (val) {
            var _this = this;
            if (!_this.active) {
                _this.slider.noUiSlider.set(_this.value);
                _this.$parent.calculate(_this.slider.id);
                _this.$emit('update:value', _this.value);
            }
        }
    },
    template: '<div class=\"form__group\">\
              <div class=\"form__richlabel\">\
                  <label for=\"\" class=\"form__label\">{{title}}</label>\
                  <div class=\"form__input-holder\">\
                      <input type=\"text\" class=\"form__input form__input--small\" v-model=\"value\" @focus="active = true" @blur="active = false" @input="handleInput()">\
                      <span class=\"form__input-placeholder\" v-show=\"icon\">{{icon}}</span>\
                  </div>\
                  <div class=\"form__checkbox-holder\">\
                      <input type=\"radio\" v-bind:id=\"identifier\" v-bind:name=\"max\" class=\"form__checkbox-input\" v-if="checkbox" :value="id" v-model="picked"  v-on:change=\"pick($event)\">\
                      <label v-bind:for=\"identifier\" class=\"form__checkbox-label\" v-if="checkbox">\
                          <span class=\"form__checkbox-phseudocheckbox\">\
                              <svg class=\"form__checkbox-icon\">\
                                  <use xlink:href=\"~/m/i/icons.svg#symbol-check\"></use>\
                              </svg>\
                          </span>\
                      </label>\
                  </div>\
              </div>\
              <div class=\"form__content\" v-if="isSlider">\
                  <div v-bind:id=\"id\"></div>\
              </div>\
            </div>\
'
});